import colors from '@theme/colors';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  bpParent: { backgroundColor: colors.neutral.cotton, flex: 1, paddingBottom: 10 },
  safeAreaView: { backgroundColor: colors.secondary.orchid, flex: 1 },
});
export default styles;
